import * as React from 'react';
import HlsVideo from './hlsVideo';
import ImageWithFocus, { Props } from './image-with-focus';

const VideoOrImage = (props: Props) => {
    const { contentMarketing } = props;
    const videoUrl = contentMarketing?.videoUrl;
    if (videoUrl) {
        return (
            <HlsVideo
                src={contentMarketing.videoUrl}
                id={contentMarketing.id}
            />
        );
    } else {
        return <ImageWithFocus {...props} />;
    }
};

export default VideoOrImage;
